import { LOGIN, LOGOUT } from '@src/graphql/queries/auth';
import { CURRENT_USER } from '@src/graphql/queries/user';
import { useUserLocale } from '@src/hooks/useUserLocale';
import { isSuperuser as isSuperuserFunc } from '@src/utilities/permissions';
import { IntlContext, Role, useAuth as useCoreAuth, } from 'pe-core-frontend';
import { useContext, useEffect, useMemo } from 'react';
export const useAuth = () => {
    const props = useCoreAuth({
        currentUserQuery: CURRENT_USER,
        loginQuery: LOGIN,
        logoutQuery: LOGOUT,
    });
    const { locale, setLocale } = useContext(IntlContext);
    const { locale: userLocale } = useUserLocale(!props.currentUser);
    const currentUser = props.currentUser;
    useEffect(() => {
        if (locale !== userLocale) {
            setLocale(userLocale);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locale, userLocale]);
    const hasPermission = (...permissions) => {
        return props.hasPermission(...permissions);
    };
    const isSuperuser = useMemo(() => isSuperuserFunc(currentUser), [currentUser]);
    const isClaimsProcessor = useMemo(() => {
        return (currentUser?.roleNames || []).includes(Role.CLAIMS_PROCESSOR) || isSuperuser;
    }, [currentUser?.roleNames, isSuperuser]);
    const isMemberSupport = useMemo(() => {
        return (currentUser?.roleNames || []).includes(Role.MEMBER_SUPPORT) || isSuperuser;
    }, [currentUser?.roleNames, isSuperuser]);
    const isManager = useMemo(() => {
        return (currentUser?.roleNames || []).includes(Role.MANAGER);
    }, [currentUser]);
    const isClientAdmin = useMemo(() => {
        return (currentUser?.roleNames || []).includes(Role.CLIENT_ADMIN);
    }, [currentUser]);
    const isEmployee = useMemo(() => {
        // return (currentUser?.roleNames || []).includes(Role.EMPLOYEE);
        return currentUser?.employeeId !== undefined && currentUser?.employeeId !== null;
    }, [currentUser]);
    return {
        ...props,
        isSuperuser,
        isClaimsProcessor,
        isManager,
        isClientAdmin,
        hasPermission,
        currentUser,
        isMemberSupport,
        isEmployee,
    };
};
